import {
  api_react_v1_current_user_info_path,
  api_user_info_path,
  api_user_update_path,
} from '@routes';
import { FeatureFlags } from '@utils/enums';

import request from './request';

export const CURRENT_USER_KEY = 'CURRENT_USER_KEY';
export const NAV_CURRENT_USER_KEY = 'NAV_CURRENT_USER_KEY';

export enum CommentableType {
  ForumPost = 'ForumPost',
  Comment = 'Community::Comment',
}

export type User = {
  access_level: number;
  administrator: {
    is_active: boolean;
  };
  affiliate_code?: string;
  app_first_open_at?: string;
  authenticated_by_jwt: boolean;
  can_actually_comment: boolean;
  can_initiate_mobile_subscription: boolean;
  can_share_article: boolean;
  can_view_comments: boolean;
  can_update_payment: boolean;
  company_name: string | null;
  comped: boolean;
  email: string;
  feature_flags: Partial<Record<FeatureFlags, boolean | string>> | Record<string, never>;
  guid: string;
  has_commented_in_forum?: boolean;
  has_set_password: boolean;
  id: number;
  identity_id: number;
  is_active_stripe_subscriber: boolean;
  is_blocked: boolean;
  is_corp_or_group_subscriber: boolean;
  is_free_edition_user: boolean;
  is_new_user: boolean;
  is_pro_subscriber: boolean;
  is_subscriber: boolean;
  login_link_only: boolean;
  name: string | null;
  one_line_bio: string | null;
  permitted_to_comment: boolean;
  picture_url: string | null;
  profile_enabled: boolean;
  referral_url: string;
  requires_name_to_comment: boolean;
  settings_access_obj: {
    referral_access: boolean;
    team_sub_access: boolean;
  };
  staff: boolean;
  subscription: {
    is_active: boolean;
    is_cbpt: boolean;
    is_monthly: boolean;
    is_past_due: boolean;
    is_pro: boolean;
    plan_type: string;
    source: string;
    onboarding: {
      status: string;
      subscribe_source: string;
      attempt_count: number;
      last_step_completed: number;
      last_attempt_at: string;
      next_attempt_at: string;
      completed_at: string;
    };
  };
  stripe_customer_id: string;
  subscription_status: string;
  title_at_company: string | null;
  username: string;
};

export interface NavCurrentUser extends User {
  adminOfOrganizationId?: number;
  avatarUrl?: string;
  canViewGiftOption: boolean;
  initialSubscribeDateStr?: string;
  isLoggedIn: boolean;
  isProSubscriber: boolean;
  isSubscriber: boolean;
  planType?: string;
  profileCompletionPercentage: number;
  profileCompletionStatuses: { text: string; isComplete: boolean; href: string }[];
  referralUrl?: string;
  shouldShowScrolledNav: boolean;
}

export type NavProps = {
  currentUser: NavCurrentUser;
  isWebview: boolean;
};

export type NavCurrentUserResponse = {
  navProps: NavProps;
};

// TODO: Adapt for other commentable types
export async function getCurrentUser(): Promise<User> {
  const resp = await request('get', api_user_info_path());
  return resp?.user;
}

export async function getNavCurrentUser(): Promise<NavCurrentUserResponse> {
  const resp = await request('get', api_react_v1_current_user_info_path());
  return resp;
}

export interface SanitizedUserParams {
  company_name?: string;
  dob?: string;
  message_enabled?: boolean;
  name?: string;
  one_line_bio?: string;
  profile_enabled?: boolean;
  public_profile?: boolean;
  title_at_company?: string;
}

export async function updateCurrentUser(values: SanitizedUserParams): Promise<{ user: User }> {
  const resp = await request('patch', api_user_update_path(values));
  return resp;
}
